import DealersDataTable from "./DealersDataTable";

export default DealersDataTable;